import InvoiceCampaign, { InvoiceCampaignEvent } from "@/types/InvoiceCampaign.interface"

interface State {
    invoiceCampaign: InvoiceCampaign
    invoiceCampaignSelectedEvent: InvoiceCampaignEvent
}

const defaults = () => {
    return {
        invoiceCampaign: null,
        invoiceCampaignSelectedEvent: null
    }
}

export default {
    state: defaults(),
    mutations: {
        invoiceCampaignSet (state: State, campaign: InvoiceCampaign): void {
            //  Update our invoice campaign
            state.invoiceCampaign = campaign

            //  Check if we have a selected invoice campaign
            const selected = state.invoiceCampaignSelectedEvent

            //  If we don't have a selected invoice campaign then we are done
            if (!selected) return

            //  Else, grab our events from our campaign
            const events = state.invoiceCampaign.events

            //  Find the event matching our selected
            const updated = events.find((x: InvoiceCampaignEvent) => x.id === selected.id) || null

            //  If our event was found, we replace it with the updated
            //  If it wasn't found, then we set it to null (probably a deletion)
            state.invoiceCampaignSelectedEvent = updated
        },
        invoiceCampaignSelectedEventSet (state: State, event: InvoiceCampaignEvent): void {
            state.invoiceCampaignSelectedEvent = event
        },
        invoiceCampaignReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        invoiceCampaignGet ({ commit, getters }): Promise<InvoiceCampaign> {
            //  Assemble the API endpoint
            const url = `${getters.api}/invoice-campaigns`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our invoice campaign
                commit('invoiceCampaignSet', response.data)

                //  Return the found invoice campaign
                return response.data
            }).catch(() => null)
        },
        invoiceCampaignPut ({ commit, getters }, campaign: InvoiceCampaign): Promise<InvoiceCampaign> {
            //  Assemble the API endpoint
            const url = `${getters.api}/invoice-campaigns`

            //  Send the request
            return window.axios.put(url, campaign).then(response => {
                //  Set our invoice campaign
                commit('invoiceCampaignSet', response.data)

                //  Return the updated invoice campaign
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        invoiceCampaign (state: State): InvoiceCampaign {
            return state.invoiceCampaign
        },
        invoiceCampaignSelectedEvent (state: State): InvoiceCampaignEvent {
            return state.invoiceCampaignSelectedEvent
        }
    }
}